export const HELP_FAQ_LIST = [
  {
    id: 0,
    question: "How do I cancel or deactivate a full access HaulPay Carrier or Broker account?",
    answer:
      "To cancel or deactivate your full access account simply navigate to the Billing section under Settings and click on the Deactivate button to close your account."
  },
  {
    id: 1,
    question:
      "If I am a carrier or broker using the web app can I only bid on loads or can I call on loads directly?",
    answer:
      "Shipper loads posted by direct shippers require a bid submitted via the HaulPay web app when viewing a shipper load. Broker loads, however, can be called on directly, bid on via the web app and messaged using the question and answer fields on the load details page for any load you find."
  },
  {
    id: 2,
    question: "What timezone are the dates and times displayed in?",
    answer:
      "All timezones are local to you. For example, if you are in PST, the time displayed is in PST."
  },
  {
    id: 3,
    question: "Is HaulPay a Freight Broker?",
    answer:
      "HaulPay is a true freight marketplace and logistics exchange and is NOT a broker or broker app. HaulPay facilitates matching, bidding, dispatching and invoicing of loads between Shippers, Carriers and Brokers. HaulPay is not to be listed as the bill to on any bill of lading for any loads found on or off of the platform."
  }
];

export const HAULPAY_FAQ_LIST = [
  {
    id: 0,
    question: "How do I submit a Funding Request?",
    answer:
      "The fastest and easiest way to submit a funding request is to download the HaulPay app on your mobile. If you prefer to use a computer or laptop, you can use the HaulPay feature in the HaulPay website. If you have any issues with our website or mobile app, please contact us at support@haulpay.com"
  },
  {
    id: 1,
    question: "What’s a Debtor?",
    answer:
      "A Debtor is a person who has placed an order on HaulPay. They are responsible for paying all of the invoices they have received from customers."
  },
  {
    id: 2,
    question: "What is NOA?",
    answer:
      "A NOA is a Notice of Assignment and it is a document that assigns the payments from your customer/debtor to us to settle invoices you’re factoring. Until this is verified by your customer via email or phone, we will not be able to disburse your funds or funds to the carrier. We do our best in contacting your customer twice a day as well as send emails with you CC'd on them for transparency. In order to avoid a payment delay due to the NOA not being verified by your customer, please use our new feature via the HaulPay website to send the NOA as soon as you know you will be working with the customer."
  }
];
